import type { PainMap, PainSeverity, BodySide } from "@heraion/shared";
import { painSides } from "@heraion/shared";

import type { TFn } from "../i18nTypes";
import { painPartsPhrase, type PainPartRef } from "./painPartsPhrase";

/** What a read-only figure says to a screen reader: the marked parts, by
 *  severity. A side is named only when the two sides differ. Exported for
 *  HomeInsightWidgets' PainMapCard (HR-11), whose Pressable needs this SAME
 *  spoken text as its accessibilityLabel once the figure itself is hidden
 *  from the a11y tree (one stop, not two). */
export function painSummary(t: TFn, painMap: PainMap, locale: string): string {
  const parts: Record<"red" | "yellow", PainPartRef[]> = { red: [], yellow: [] };
  for (const [slug, entry] of Object.entries(painMap)) {
    const sides = painSides(entry);
    const both = sides.left === sides.right ? sides.left : undefined;
    const marks: [PainSeverity | undefined, BodySide | undefined][] = both
      ? [[both, undefined]]
      : [[sides.left, "left"], [sides.right, "right"]];
    for (const [sev, side] of marks) {
      if (sev !== "red" && sev !== "yellow") continue;
      parts[sev].push({ slug, side });
    }
  }
  return [
    t("bodymap.painTitle"),
    parts.red.length
      ? t("bodymap.painSummaryAvoid", { parts: painPartsPhrase(t, parts.red, locale) })
      : "",
    parts.yellow.length
      ? t("bodymap.painSummaryCaution", {
          parts: painPartsPhrase(t, parts.yellow, locale),
        })
      : "",
  ]
    .filter(Boolean)
    .join(". ");
}
